import { useQuery } from '@tanstack/react-query';
import { getRefundDetails } from '../services/direct';

export const useRefundDetails = () => {
  return useQuery({
    queryKey: ['refundDetails'],
    queryFn: () => getRefundDetails(),
  });
};
